import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, errMsg } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined = checking, null = anon, obj = auth

  useEffect(() => {
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => setUser(null));
  }, []);

  const login = useCallback(async (email, password) => {
    try {
      const r = await api.post("/auth/login", { email, password });
      setUser(r.data);
      return { ok: true };
    } catch (e) {
      return { ok: false, error: errMsg(e) };
    }
  }, []);

  const register = useCallback(async (email, password, name) => {
    try {
      const r = await api.post("/auth/register", { email, password, name });
      setUser(r.data);
      return { ok: true };
    } catch (e) {
      return { ok: false, error: errMsg(e) };
    }
  }, []);

  const logout = useCallback(async () => {
    try {
      await api.post("/auth/logout");
    } catch (e) {
      /* ignore */
    }
    setUser(null);
  }, []);

  const changePassword = useCallback(async (current_password, new_password) => {
    try {
      await api.post("/auth/change-password", { current_password, new_password });
      setUser((u) => (u ? { ...u, password_is_temporary: false } : u));
      return { ok: true };
    } catch (e) {
      return { ok: false, error: errMsg(e) };
    }
  }, []);

  return (
    <AuthContext.Provider value={{ user, setUser, login, register, logout, changePassword }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
